var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.555,
    height: 84.555,
    viewBox: "0 0 84.555 84.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724",
    transform: "translate(1482.528 -995.223)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 42.277,
    cy: 42.277,
    r: 42.277,
    transform: "translate(-1482.528 995.223)",
    fill: "#ffd442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718",
    transform: "translate(-1466.423 1013.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M3666.9,1119.246a10.1,10.1,0,0,0,10.547-4.673",
    transform: "translate(-3666.898 -1114.573)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M0,4.673A10.1,10.1,0,0,0,10.547,0",
    transform: "translate(43.907 0.88) rotate(49)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(0.41 13.8)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(36.648 13.8)",
    fill: "#594504"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M3670.246,1130.517s6.621-17.053,23.7,1.5",
    transform: "translate(-5123.188 -74.335)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2",
    "data-name": "Path 1756",
    d: "M3666.9,1119.246a10.1,10.1,0,0,0,10.547-4.673",
    transform: "translate(-5133.321 -100.939)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759-2",
    "data-name": "Path 1759",
    d: "M0,4.673A10.1,10.1,0,0,0,10.547,0",
    transform: "translate(-1422.515 1014.514) rotate(49)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(-1466.013 1027.434)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-2",
    "data-name": "Ellipse 45",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(-1429.775 1027.434)",
    fill: "#594504"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile2);
export default __webpack_public_path__ + "static/media/smile2.e4ae706eae5779bf7d09f788ff26d7ab.svg";
export { ForwardRef as ReactComponent };